import { LoadingManager as BaseManager, TextureLoader, ImageLoader } from 'three'

import { FBXLoader } from './FBXLoader'
import { GLTFLoader } from './GLTFLoader'

export class LoadingManager extends BaseManager {
  constructor () {
    super()

    this.setBaseUrl = this.setBaseUrl.bind(this)

    this._imageManager = new BaseManager()
    this._imageManager.resolveURL = url => {
      if (!url.startsWith('http')) {
        if (!url.startsWith('textures')) {
          url = 'textures/' + url // dirty fix that works for sketchfab files
        }

        url = this._baseUrl + url
      }

      if (url.endsWith('.tga')) { // dirty fix that works for sketchfab files
        url += '.png'
      }

      return url
    }

    this.addHandler(/\.tga$/i, new TextureLoader(this._imageManager))
  }

  setBaseUrl (url) {
    this._baseUrl = url.split('/').slice(0, -2).join('/') + '/'
  }
}

class BaseLoader {
  constructor () {
    this.load = this.load.bind(this)

    this.loadingManager = new LoadingManager()
    this.FBXLoader = new FBXLoader(this.loadingManager)
    this.GLTFLoader = new GLTFLoader(this.loadingManager)
  }

  load (url, ...args) {
    this.loadingManager.setBaseUrl(url)

    if (url.toLowerCase().endsWith('.gltf') || url.toLowerCase().endsWith('.glb')) {
      return this.GLTFLoader.load(url, ...args)
    }
    else if (url.toLowerCase().endsWith('.fbx')) {
      return this.FBXLoader.load(url,  ...args)
    }
  }
}

export const Loader = new BaseLoader()